<template>
  <RevCardCarousel
    :id="textToTarget(title, 'heading-2')"
    :next-alternative-text="i18n(translations.alternativeNext)"
    :prev-alternative-text="i18n(translations.alternativePrevious)"
    :subtitle="subtitle || ''"
    :title
  >
    <div v-for="(review, index) in reviews" :key="review.id" class="h-full">
      <ReviewCard :review @click="() => handleReviewCardClick(index)" />
    </div>
  </RevCardCarousel>
</template>

<script lang="ts" setup>
import type { Tracking } from '@backmarket/http-api/src/api-specs-content/models/tracking'
import type {
  ReviewCustomer,
  ReviewProduct,
  SalesOrderItem,
} from '@backmarket/http-api/src/api-specs-reviews/types/review'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { RevCardCarousel } from '@ds/components/CardCarousel'

import { textToTarget } from '../../../utils/textToTarget'
import translations from '../Reviews.translations'

import ReviewCard from './ReviewCard.vue'

export type Review = {
  product: ReviewProduct
  customer: ReviewCustomer
  pictures: string[]
  id: string
  comment: string
  averageRate: number
  countryCode: string
  languageCode: string
  reviewDate: string
  purchaseDate: string
  salesOrderItem: SalesOrderItem
}
const props = defineProps<{
  title: string
  subtitle?: Maybe<string>
  reviews: Review[]
  tracking?: Tracking
}>()

const i18n = useI18n()

const { trackClick } = useTracking()

function handleReviewCardClick(index: number) {
  const review = props.reviews[index]

  trackClick({
    ...props.tracking,
    position: index + 1,
    reviewRating: review.averageRate,
    reviewComment: review.comment,
    reviewId: review.id,
  })
}
</script>
